// extracted by mini-css-extract-plugin
module.exports = {"change-password-form":"ChangePasswordForm_change-password-form__y60PS","footer":"ChangePasswordForm_footer__1ycLA"};